const localizers = {
  'loading.msg': () => `Učitavanje...`,
  'logon.message.msg': () => `Obavezna je provjera autentičnosti. Unesite valjani korisnički ID i lozinku.`,
  'logon.button.msg': () => `Prijava...`,
  'SASServer.logonError.msg': () => `Prijava na poslužitelj nije moguća.`,
  'SASServer.genericError.msg': () => `Nije moguće uspostaviti vezu s poslužiteljem.`,
}
export default localizers;
